<div class="selection-panel-wrapper" *ngIf="isVisible">
  <div class="selection-panel">
    <div class="selection-section">
      <div class="selection-title">{{ 'request_v2.department_form.selection_color' | translate }}</div>
      
      <div class="color-grid">
        <div *ngFor="let color of colors" 
             class="color-item" 
             [style.backgroundColor]="color"
             [class.selected]="selectedColor === color"
             (click)="onColorSelect(color, $event)">
        </div>
      </div>
    </div>
  </div>
</div> 